"use client";

import mobileMenuItems from "@/data/mobileMenuItems";
import { usePathname } from "next/navigation";
import Link from "next/link";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { useEffect, useState } from "react";

const MobileNavbarMenu = () => {
      const pathname = usePathname();
      const [topMenu, setTopMenu] = useState("");
      const [appStoreUrl, setAppStoreUrl] = useState("https://play.google.com/store/apps/details?id=com.bonoholdings.proptech");

      useEffect(() => {
            // Detect platform and set appropriate app store URL
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            const platform = navigator.platform || navigator.userAgentData?.platform || "";

            // Check for iOS (iPhone, iPad, iPod)
            const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
            // Check for Mac
            const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/.test(platform);
            // Check for Android
            const isAndroid = /android/i.test(userAgent);
            // Check for Windows
            const isWindows = /Win/.test(platform);

            if (isIOS || isMac) {
                  setAppStoreUrl("https://apps.apple.com/gb/app/olmo-homes/id6747893455");
            } else if (isAndroid || isWindows) {
                  setAppStoreUrl("https://play.google.com/store/apps/details?id=com.bonoholdings.proptech");
            }
      }, []);

      useEffect(() => {
            if (pathname.split("/")?.[1]) {
                  setTopMenu(pathname.split("/")?.[1]);
            }
      }, [pathname]);

      const scrollToSection = (id) => {
            if (typeof document === "undefined") return;

            const el = document.getElementById(id);
            if (!el) return;

            el.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
            });
      };

      return (
            <Sidebar width="100%" backgroundColor="#fff" className="my-custom-class">
                  <Menu>
                        {mobileMenuItems.map((item, index) => (
                              <MenuItem
                                    key={index}
                                    component={<Link href={item.path} />}
                                    className={item.path === pathname ? "active" : ""}
                                    onClick={(e) => {
                                          e.preventDefault();
                                          scrollToSection(item.section);
                                          setTopMenu(item.section);
                                    }}
                              >
                                    {item.label}
                              </MenuItem>
                        ))}
                        <MenuItem
                              component={<Link href={appStoreUrl} target="_blank" />}
                              className="active"
                              onClick={(e) => {
                                    e.preventDefault();
                                    window.open(appStoreUrl, "_blank");
                              }}
                        >
                              Download Olmo
                        </MenuItem>
                  </Menu>
            </Sidebar>
      );
};

export default MobileNavbarMenu;


